import { appendFormDataWithObjectValues, customFetch } from 'utils/http';
import { HTTPResponseError } from 'utils/errors';
import { getM8AdminURL } from 'services/production/utils/getM8URL';

type Params = {
  idPartner: number;
};

export const generateNewPartnerCode = async (
  params: Params
): Promise<string> => {
  const formData = new FormData();

  appendFormDataWithObjectValues(formData, params);

  const response = await customFetch(getM8AdminURL('generateNewPartnerCode'), {
    method: 'POST',
    body: formData,
  });

  if (!response.ok) {
    throw new HTTPResponseError(response);
  }

  return response.text();
};
